/* eslint-disable react/no-array-index-key */
import React from "react";
import PersonalInfoIcon from "assets/personal_info.svg";

interface PersonalInformationProps {
  name: string[];
  alsoKnownAs: string[];
  dateOfBirth: string;
  socialSecurityNumber: string;
  addressesReported: string[];
  employers: string[];
  className: string;
}

export const PersonalInformation: React.FC<PersonalInformationProps> = ({
  name,
  alsoKnownAs,
  dateOfBirth,
  socialSecurityNumber,
  addressesReported,
  employers,
  className,
}) => {
  return (
    <div className={className}>
      <h2 className="text-2xl font-bold flex items-center">
        <img alt="" src={PersonalInfoIcon} className="inline mr-2" />
        Personal information
      </h2>
      <div className="mt-4 bg-white rounded-md border border-neutral-400 p-8 flex">
        <div className="flex-1">
          <div className="mb-4">
            <h3 className="font-bold mb-1">Name</h3>
            <p>{name}</p>
          </div>
          <div className="mb-4">
            <h3 className="font-bold mb-1">Also known as</h3>
            <div className="flex flex-col space-y-4">
              {alsoKnownAs.map((aka, index) => (
                <p key={`aka-${index}`}>{aka}</p>
              ))}
            </div>
          </div>
          <div className="mb-4">
            <h3 className="font-bold mb-1">Date of birth</h3>
            <p>{dateOfBirth}</p>
          </div>
          <div className="mb-4">
            <h3 className="font-bold mb-1">Social security number</h3>
            <p>{socialSecurityNumber}</p>
          </div>
        </div>
        <div className="flex-1 ml-10">
          <div className="mb-4">
            <h3 className="font-bold mb-1">Address reported</h3>
            <div className="flex flex-col space-y-4">
              {addressesReported.map((address, index) => (
                <p key={`address-${index}`}>{address}</p>
              ))}
            </div>
          </div>
          <div className="mb-4">
            <h3 className="font-bold mb-1">Employer</h3>
            <div className="flex flex-col space-y-4">
              {employers.map((employer, index) => (
                <p key={`employer-${index}`}>{employer}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
